const trimString = (string, limit) => {
  const words = string.split(' ');

  return words.length > limit
    ? `${words.slice(0, limit).join(' ')}...`
    : string;
};

export default trimString;
